<template>
  <section class="px-1 relative overflow-hidden">
    <!-- Middle line -->
    <Wave
      path="line"
      alignment="top"
      color="text-primary"
      class="hidden lg:block"
      additional-class="mt-8 opacity-20"
      svg-class="mt-9"
    />
    <div class="container py-5 md:py-6 lg:pb-0">
      <div class="row justify-center">
        <div class="lg:col-6">
          <header class="mb-5 lg:mb-6">
            <h2 class="mb-2 lg:mb-5 text-center">
              {{ t('favorite_products') }}
            </h2>
          </header>
        </div>
        <!-- Bottom small bubble -->
        <div class="col-1 p-0 absolute bottom-0 right-0 mb-8 mr-n7 hidden xxl:block embed-responsive embed-responsive-1by1 bg-light opacity-40 pattern-2 mb-8" />
        <!-- Bottom small left bubble -->
        <div class="col-2 p-0 absolute  bottom-0 left-0 mb-8 ml-n9 pr-5 hidden lg:block embed-responsive embed-responsive-1by1 bg-light opacity-40 pattern-2" />
        <!-- Middle bubble -->
        <div class="col-3 pl-8 pr-0 absolute left-40 top-0 mt-9 ml-6 hidden lg:block embed-responsive embed-responsive-1by1 bg-light opacity-40 pattern-2 mt-6" />
        <!-- Carousel -->
        <Carousel
          v-if="crossSell?.length > 0"
          :slides="crossSell"
          class="col-12"
        />
        <BaseLoading
          v-else
          :style="{ minHeight: '670px' }"
        />
      </div>
    </div>
    <!-- bottom gap because of footer waves -->
    <div class="py-2 md:py-3 lg:py-8" />
  </section>
</template>

<script setup>
import { ref } from 'vue'
import { useI18n } from 'vue-i18n'

import BaseLoading from '@/components/general/BaseLoading.vue'
import Wave from '@/components/general/BaseWave.vue'
import Carousel from '@/components/carousel/Carousel.vue'
import { useProductStore } from '@/stores/ProductStore'

const { t } = useI18n()

const productStore = useProductStore()

const crossSell = ref()

const loadCrossSell = async () => {
  crossSell.value = await productStore.loadCrossSell('quantity=6&kind=homepage_favorite_cross_sell')
}

loadCrossSell()
</script>

<i18n>
  {
    "cs": {
    "favorite_products": "Nejoblíbenější Mixit"
},
    "sk": {
    "favorite_products": "Najobľúbenejší Mixit"
},
    "pl": {
    "favorite_products": "Najpopularniejsze produkty Mixit"
},
    "hu": {
    "favorite_products": "Legnépszerűbb"
},
    "de": {
    "favorite_products": "Unsere beliebtesten Leckereien"
},
    "at": {
    "favorite_products": "Unsere beliebtesten Leckereien"
},
    "ro": {
    "favorite_products": "Cele mai populare gustări ale noastre"
},
    "fr": {
    "favorite_products": "Mixit le plus populaire"
},
    "it": {
    "favorite_products": "I Mixit più popolari"
}
  }
</i18n>
